import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import axios from 'axios';
import { API_URL } from '../../config';

const AskExpertForm = () => {
  const [subscriberName, setSubscriberName] = useState('');
  const [askQuestion, setAskQuestion] = useState('');
  const [givenAnswer, setGivenAnswer] = useState('');
  const [status, setStatus] = useState(1); // Default: Published

  const { id } = useParams();
  const navigate = useNavigate();

  // Load existing data (edit mode)
  useEffect(() => {
    if (id) fetchQuestion(id);
  }, [id]);

  const fetchQuestion = async (id) => {
    try {
      const response = await axios.get(`${API_URL}ask-expert/add?id=${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('authToken')}`,
        },
      });

      const data = response.data.askexpert;
      setSubscriberName(data.subscribername || '');
      setAskQuestion(data.t1_askquestion || '');
      setGivenAnswer(data.t1_givenanswer || '');
      setStatus(data.t1_status ?? 1);
    } catch (error) {
      Swal.fire('Error', 'Could not fetch question details.', 'error');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!askQuestion || !givenAnswer) {
      Swal.fire('Error', 'Please fill in all fields.', 'error');
      return;
    }

    const formData = {
      subscribername: subscriberName,
      askquestion: askQuestion,
      givenanswer: givenAnswer,
      status,
    };

    try {
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('authToken')}`,
        },
      };

      if (id) {
        await axios.put(`${API_URL}ask-expert/${id}`, formData, config);
        Swal.fire('Success', 'Question updated successfully!', 'success');
      } else {
        await axios.post(`${API_URL}ask-expert`, formData, config);
        Swal.fire('Success', 'Question added successfully!', 'success');
      }

      navigate('/website/askexpert');
    } catch (err) {
      Swal.fire('Error', err.response?.data?.message || 'Failed to save the question.', 'error');
    }
  };

  return (
    <div id="page-container" className="page-header-fixed page-sidebar-fixed fade in">
      <div id="content" className="">
        <div className="panel panel-default with-rounded-corner with-shadow">
          <div className="panel-heading">
            <span className="panel-title">{id ? 'Edit' : 'Add'} Ask Expert</span>
          </div>

          <div className="panel-body">
            <form className="stdform" onSubmit={handleSubmit}>
              <div className="row">
                {/* Subscriber Name */}
                <div className="form-group col-md-4">
                  <label>Subscriber Name</label>
                  <input
                    type="text"
                    className="form-control"
                    value={subscriberName}
                    onChange={(e) => setSubscriberName(e.target.value)}
                    placeholder="Enter Subscriber Name"
                  />
                </div>

                {/* Status Dropdown */}
                <div className="form-group col-md-4">
                  <label>Publish Status</label>
                  <select
                    className="form-control"
                    value={status}
                    onChange={(e) => setStatus(Number(e.target.value))}
                  >
                    <option value={0}>UnPublished</option>
                    <option value={1}>Published</option>
                  </select>
                </div>

                {/* Empty space */}
                <div className="col-md-4"></div>

                {/* Question Asked */}
                <div className="form-group col-md-12">
                  <label>Question Asked</label>
                  <textarea
                    className="form-control"
                    value={askQuestion}
                    onChange={(e) => setAskQuestion(e.target.value)}
                    placeholder="Enter Question Asked"
                  />
                </div>

                {/* Answer Given */}
                <div className="form-group col-md-12">
                  <label>Answer Given</label>
                  <textarea
                    className="form-control"
                    value={givenAnswer}
                    onChange={(e) => setGivenAnswer(e.target.value)}
                    placeholder="Enter Answer Given"
                  />
                </div>

                {/* Buttons */}
                <div className="form-group col-md-12">
                  <button type="submit" className="btn btn-primary">
                    {id ? 'Submit' : 'Save'}
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary mx-2 btn-danger"
                    onClick={() => navigate('/website/askexpert')}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>

        {/* Scroll to top */}
        <a href="#" data-click="scroll-top" className="btn-scroll-top fade">
          <i className="ti-arrow-up"></i>
        </a>
      </div>
    </div>
  );
};

export default AskExpertForm;
